import React from 'react';
import { heroContent } from '../data';
import { HeroProps } from '../types';
import HeroPresentation from './HeroPresentation';

const HeroContainer: React.FC<HeroProps> = ({ 
  className, 
  id = 'hero' 
}) => {
  const handlePrimaryButtonClick = () => {
    // Analytics tracking or other side effects
    console.log('Primary hero button clicked');
  };

  const handleSecondaryButtonClick = () => {
    // Analytics tracking or other side effects
    console.log('Secondary hero button clicked');
  };

  return (
    <HeroPresentation
      id={id}
      content={heroContent}
      onPrimaryButtonClick={handlePrimaryButtonClick}
      onSecondaryButtonClick={handleSecondaryButtonClick}
    />
  );
};

export default HeroContainer;